export const CONTACTS_REQUEST = "Contacts.Request";
export const CONTACTS_SUCCESS = "Contacts.Success";
export const CONTACTS_FAILURE = "Contacts.Failure";
export const CONTACTS_RESET = "Contacts.Reset";


export function getContacts(data?:any) {
  return (dispatch, getState) => {
    const { auth } = getState();
    const params = data || {};
    dispatch({ type: CONTACTS_REQUEST });
    const queryParams = new URLSearchParams({
      page: params.page ?? 0,    
      limit: params.limit ?? 10
    }).toString();

    return fetch(`/api/contacts/?${queryParams}`, {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${auth.token}`,
        "Content-Type": "application/json",
      },
    }).then(async (response) => {
      const data = await response.json();
      if (data.status === "success") {
        dispatch({
          type: CONTACTS_SUCCESS,
          payload: data.result,
        });
      } else {
        dispatch({ type: CONTACTS_FAILURE, payload: data });
      }
    });
  };
}
// -----------------------------------------------------------------------


export const CONTACTS_POST_REQUEST = "ContactsPost.Request";
export const CONTACTS_POST_SUCCESS = "ContactsPost.Success";
export const CONTACTS_POST_FAILURE = "ContactsPost.Failure";
export const CONTACTS_POST_RESET = "ContactsPost.Reset";

export function addContacts(data) {

  return (dispatch, getState) => {
    const { auth } = getState();
    dispatch({ type: CONTACTS_POST_REQUEST });
    return fetch(`/api/contacts/`, {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${auth.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    }).then(async (response) => {
      const data = await response.json();
      if (data.status === "success") {
        dispatch({
          type: CONTACTS_POST_SUCCESS,
          payload: data.result,
        });
      } else {
        dispatch({ type: CONTACTS_POST_FAILURE, payload: data });
      }
    });
  };
}
// { body
//   "email": "user@example.com",
//   "code": "string",
//   "firstname": "string",
//   "lastname": "string",
//   "middlename": "string",
//   "primary": false
// }
// -----------------------------------------------------------------------

export const CONTACTS_SEARCH_REQUEST = "ContactsSearch.Request";
export const CONTACTS_SEARCH_SUCCESS = "ContactsSearch.Success";
export const CONTACTS_SEARCH_FAILURE = "ContactsSearch.Failure";
export const CONTACTS_SEARCH_RESET   = "ContactsSearch.Reset";

export function searchContacts(params: { code?: string; email?: string }) {
  return (dispatch, getState) => {
    const { auth } = getState();
    dispatch({ type: CONTACTS_SEARCH_REQUEST });
    const entries = Object.entries(params).filter(([, v]) => v?.trim());
    if (!entries.length) return;
    const queryParams = new URLSearchParams(Object.fromEntries(entries)).toString();
    return fetch(`/api/contacts/search?${queryParams}`, {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${auth.token}`,
        "Content-Type": "application/json",
      },
    }).then(async (response) => {
      const data = await response.json();
      if (data.status === "success") {
        dispatch({ type: CONTACTS_SEARCH_SUCCESS, payload: data.result });
      } else {
        dispatch({ type: CONTACTS_SEARCH_FAILURE, payload: data });
      }
    });
  };
}
// -----------------------------------------------------------------------

export const CONTACTS_DELETE_REQUEST = "ContactsDelete.Request";
export const CONTACTS_DELETE_SUCCESS = "ContactsDelete.Success";
export const CONTACTS_DELETE_FAILURE = "ContactsDelete.Failure";
export const CONTACTS_DELETE_RESET   = "ContactsDelete.Reset";

export function deleteContact(id: string) {
  return (dispatch, getState) => {
    const { auth } = getState();
    dispatch({ type: CONTACTS_DELETE_REQUEST });
    return fetch(`/api/contacts/${id}`, {
      method: "DELETE",
      headers: {
        "Authorization": `Bearer ${auth.token}`,
      },
    }).then(async (response) => {
      const data = await response.json();
      if (data.status === "success") {
        dispatch({ type: CONTACTS_DELETE_SUCCESS, payload: id });
      } else {
        dispatch({ type: CONTACTS_DELETE_FAILURE, payload: data });
      }
    });
  };
}